import { CameraTuple } from "././CameraTuple";

declare const STAGE: any;

export class OrbitControlCameraTupleMapper {
  constructor() { }

  getCurrentCamera(): CameraTuple {
    return new CameraTuple(
      STAGE.orbitcontrols.object.position,
      STAGE.orbitcontrols.target,
      STAGE.orbitcontrols.object.up,
    );
  }

  setCurrentCamera(cameraTuple: CameraTuple): void {
    STAGE.orbitcontrols.object.position.copy(cameraTuple.position);
    STAGE.orbitcontrols.target.copy(cameraTuple.target);
    STAGE.orbitcontrols.object.up.copy(cameraTuple.up);
    STAGE.orbitcontrols.update();
  }
}
